module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/fa98f5b1ca0cc2943e19ecd1d2d2cbb0.svg";